(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cus-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('palm-social-proof')) {
    customElements.define('palm-social-proof', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('[data-psp-track]');
        if (!this.track) return;
        this.previous = this.querySelector('[data-psp-prev]');
        this.next = this.querySelector('[data-psp-next]');
        this.progress = this.querySelector('[data-psp-progress]');
        this.thumb = this.querySelector('[data-psp-thumb]');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.dataset.pspReady = 'true';
        this.previous?.addEventListener('click', () => this.move(-1), {signal});
        this.next?.addEventListener('click', () => this.move(1), {signal});
        this.track.addEventListener('scroll', () => this.schedule(), {passive:true,signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.jump(0);
          else if (event.key === 'End') this.jump(this.maximum());
          else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
        }, {signal});
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-psp-expand]');
          if (!button) return;
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.closest('.psp__card').classList.toggle('is-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
          this.schedule();
        }, {signal});
        this.addEventListener('play', event => {
          if (event.target.tagName !== 'VIDEO') return;
          this.querySelectorAll('video').forEach(video => { if (video !== event.target) video.pause(); });
        }, {capture:true,signal});
        this.addEventListener('error', event => {
          if (event.target.tagName !== 'VIDEO') return;
          event.target.closest('.psp__card')?.querySelector('.psp__story-link')?.removeAttribute('hidden');
        }, {capture:true,signal});
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseVideos(); }, {signal});
        document.addEventListener('shopify:block:select', event => {
          const item = [...this.querySelectorAll('[data-psp-story]')].find(item => item.dataset.pspStory === event.detail.blockId);
          if (item) item.scrollIntoView({behavior:'instant',block:'nearest',inline:'start'});
        }, {signal});
        this.resize = new ResizeObserver(() => this.schedule());
        this.resize.observe(this.track);
        this.querySelectorAll('.psp__quote').forEach(text => this.resize.observe(text));
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
            const video = entry.target;
            if (!entry.isIntersecting) video.pause();
            else if (!video.poster && video.dataset.pspMetadata !== 'true') {
              video.dataset.pspMetadata = 'true';
              video.preload = 'metadata';
              video.load();
            }
          }), {threshold:.1});
          this.querySelectorAll('video').forEach(video => this.videoObserver.observe(video));
        }
        this.schedule();
      }
      disconnectedCallback() {
        this.abort?.abort();this.resize?.disconnect();this.videoObserver?.disconnect();
        cancelAnimationFrame(this.frame);this.pauseVideos();
      }
      pauseVideos() { this.querySelectorAll('video').forEach(video => video.pause()); }
      maximum() { return Math.max(this.track.scrollWidth - this.track.clientWidth, 0); }
      position() { return Math.max(0, Math.min(this.maximum(), this.track.scrollLeft * (this.rtl ? -1 : 1))); }
      jump(position) { this.track.scrollTo({left:position * (this.rtl ? -1 : 1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); }
      move(direction) { this.jump(Math.max(0,Math.min(this.maximum(),this.position()+direction*Math.max(this.track.clientWidth*.86,280)))); }
      schedule() { cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update()); }
      update() {
        const overflow=this.maximum(),position=this.position();
        if(this.previous)this.previous.disabled=position<=2;
        if(this.next)this.next.disabled=overflow-position<=2;
        if(this.progress)this.progress.hidden=overflow<=2;
        const ratio=this.track.scrollWidth?Math.min(this.track.clientWidth/this.track.scrollWidth,1):1;
        if(this.thumb){this.thumb.style.width=`${ratio*100}%`;this.thumb.style.transform=`translateX(${overflow?position/overflow*((1-ratio)/ratio)*100*(this.rtl?-1:1):0}%)`;}
        this.querySelectorAll('[data-psp-text]').forEach(text=>{
          const button=text.parentElement.querySelector('[data-psp-expand]');
          if(button)button.hidden=button.getAttribute('aria-expanded')!=='true'&&text.scrollHeight<=text.clientHeight+2;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-community-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('palm-community-hero')) {
  customElements.define('palm-community-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.states = [];
      this.frame = null;
      this.lastTime = null;
      this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
      this.pointer = matchMedia('(hover:hover) and (pointer:fine)');
      this.querySelectorAll('.pch__slot').forEach(slot => {
        const state = {slot,card:slot.querySelector('.pch__card'),value:[0,0,0,0,1],target:[0,0,0,0,1],velocity:[0,0,0,0,0],origin:null};
        this.states.push(state);
        slot.addEventListener('pointerenter', event => {
          if (this.reduce.matches || !this.pointer.matches || event.pointerType === 'touch') return;
          const r=slot.getBoundingClientRect();
          state.origin={x:r.left+r.width/2,y:r.top+r.height/2,w:r.width,h:r.height};
          state.target[4]=1.025;
          slot.dataset.motion='active';
          this.wake();
        },{signal});
        slot.addEventListener('pointermove',event=>{
          if(!state.origin || this.reduce.matches)return;
          const x=Math.max(-1,Math.min(1,(event.clientX-state.origin.x)/(state.origin.w/2)));
          const y=Math.max(-1,Math.min(1,(event.clientY-state.origin.y)/(state.origin.h/2)));
          state.target=[-y*5.5,x*5.5,x*3,y*3,1.025];
          state.card.style.setProperty('--pch-light-x',((x+1)*50)+'%');
          state.card.style.setProperty('--pch-light-y',((y+1)*50)+'%');
          this.wake();
        },{signal});
        const release=()=>{state.origin=null;state.target=[0,0,0,0,1];this.wake();};
        slot.addEventListener('pointerleave',release,{signal});
        slot.addEventListener('pointercancel',release,{signal});
      });
      this.reduce.addEventListener('change',()=>this.reset(),{signal});
      this.pointer.addEventListener('change',()=>this.reset(),{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.reset();},{signal});
      window.addEventListener('resize',()=>this.reset(),{signal});
      document.addEventListener('shopify:block:select',event=>{
        if(this.contains(event.target))event.target.classList.add('is-editor-selected');
      },{signal});
      document.addEventListener('shopify:block:deselect',event=>event.target.classList.remove('is-editor-selected'),{signal});
    }
    disconnectedCallback(){this.reset();this.controller?.abort();}
    wake(){if(this.frame===null)this.frame=requestAnimationFrame(time=>this.tick(time));}
    tick(time){
      this.frame=null;
      const steps=Math.min(2.5,(time-(this.lastTime??time-16.67))/16.67);
      this.lastTime=time;
      let moving=false;
      for(const state of this.states){
        let active=false;
        for(let i=0;i<5;i++){
          state.velocity[i]=(state.velocity[i]+(state.target[i]-state.value[i])*.115*steps)*Math.pow(.73,steps);
          state.value[i]+=state.velocity[i]*steps;
          if(Math.abs(state.target[i]-state.value[i])>.0005 || Math.abs(state.velocity[i])>.0005)active=true;
          else{state.value[i]=state.target[i];state.velocity[i]=0;}
        }
        const [rx,ry,x,y,scale]=state.value;
        state.card.style.transform='translate3d('+x+'px,'+y+'px,0) rotateX('+rx+'deg) rotateY('+ry+'deg) scale('+scale+')';
        if(!active&&!state.origin)delete state.slot.dataset.motion;
        moving ||= active;
      }
      if(moving)this.wake();else this.lastTime=null;
    }
    reset(){
      if(this.frame!==null)cancelAnimationFrame(this.frame);
      this.frame=null;this.lastTime=null;
      for(const s of this.states??[]){s.value=[0,0,0,0,1];s.target=[0,0,0,0,1];s.velocity=[0,0,0,0,0];s.origin=null;s.card.style.transform='';delete s.slot.dataset.motion;}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-community-moments"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let pinterestReady;
    const loadPinterest = () => {
      if (window.PinUtils?.build) return Promise.resolve();
      if (pinterestReady) return pinterestReady;
      pinterestReady = new Promise(resolve => {
        const script = document.createElement('script');
        script.src = 'https://assets.pinterest.com/js/pinit.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = resolve;
        document.head.append(script);
      });
      return pinterestReady;
    };
    const loadTikTok = async media => {
      if (media.dataset.loaded) return;
      media.dataset.loaded = 'true';
      let url;
      try { url = new URL(media.dataset.momentsTiktok); } catch { return; }
      if (!['tiktok.com', 'www.tiktok.com', 'vm.tiktok.com', 'vt.tiktok.com'].includes(url.hostname)) return;
      let id = url.pathname.match(/\/(?:video|photo)\/(\d{10,25})(?:\/|$)/)?.[1];
      if (!id) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 6000);
        try {
          const response = await fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(url.href)}`, {signal: controller.signal});
          if (response.ok) {
            const result = await response.json();
            const document = new DOMParser().parseFromString(result.html || '', 'text/html');
            id = document.querySelector('[data-video-id]')?.getAttribute('data-video-id');
          }
        } catch {} finally { clearTimeout(timeout); }
      }
      if (!/^\d{10,25}$/.test(id || '')) return;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.tiktok.com/player/v1/${id}?autoplay=0&controls=1&description=0&music_info=0`;
      iframe.title = media.dataset.embedTitle;
      iframe.loading = 'lazy';
      iframe.allow = 'fullscreen; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      media.replaceChildren(iframe);
    };
    const init = (root = document) => root.querySelectorAll('[data-palm-moments]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('[data-moments-track]');
      const controls = section.querySelector('[data-moments-controls]');
      const previous = section.querySelector('[data-moments-prev]');
      const next = section.querySelector('[data-moments-next]');
      const dialog = section.querySelector('[data-moments-dialog]');
      const detail = section.querySelector('[data-moments-detail]');
      let trigger;
      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflow;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => {
        const card = track.querySelector('[data-moments-card]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      const resize = new ResizeObserver(update);
      resize.observe(track);
      section.addEventListener('click', event => {
        const button = event.target.closest('[data-moments-expand]');
        if (!button || !section.contains(button)) return;
        trigger = button;
        const card = button.closest('[data-moments-card]');
        card.querySelectorAll('video').forEach(video => video.pause());
        const clone = card.cloneNode(true);
        clone.querySelector('.palm-moments__card-tools')?.remove();
        clone.removeAttribute('data-moments-card');
        clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(element => element.removeAttribute('data-shopify-editor-block'));
        detail.replaceChildren(clone);
        dialog.showModal();
        clone.querySelectorAll('[data-moments-tiktok]').forEach(loadTikTok);
        if (clone.querySelector('[data-moments-pinterest]')) loadPinterest().then(() => window.PinUtils?.build?.(clone));
      });
      section.querySelector('[data-moments-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { detail.querySelectorAll('video').forEach(video => video.pause()); detail.replaceChildren(); trigger?.focus({preventScroll:true}); });
      const lazy = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        lazy.unobserve(entry.target);
        if (entry.target.hasAttribute('data-moments-tiktok')) loadTikTok(entry.target);
        if (entry.target.hasAttribute('data-moments-pinterest')) loadPinterest().then(() => window.PinUtils?.build?.(entry.target));
      }), {rootMargin:'180px'});
      section.querySelectorAll('[data-moments-tiktok], [data-moments-pinterest]').forEach(element => lazy.observe(element));
      section.querySelectorAll('video').forEach(video => video.addEventListener('play', () => section.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); })));
      const unload = event => {
        if (!event.target.contains(section)) return;
        resize.disconnect();
        lazy.disconnect();
        dialog.close();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      update();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:block:select', event => event.target.closest('[data-moments-card]')?.scrollIntoView({block:'nearest', inline:'center', behavior:'instant'}));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-experience-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('palm-stories')) {
    customElements.define('palm-stories', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-stories-track]');
        if (!this.track) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.cards = [...this.track.querySelectorAll('[data-story-id]')];
        this.previous = this.querySelector('[data-stories-prev]');
        this.next = this.querySelector('[data-stories-next]');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.previous.addEventListener('click', () => this.move(-1), {signal});
        this.next.addEventListener('click', () => this.move(1), {signal});
        this.track.addEventListener('scroll', () => this.schedule(), {passive:true,signal});
        this.track.addEventListener('click', event => {
          const button = event.target.closest('[data-story-expand]');
          if (!button) return;
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.closest('.ps__card').classList.toggle('is-expanded', expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? this.dataset.readLess : this.dataset.readMore;
          this.schedule();
        }, {signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.jump(0);
          else if (event.key === 'End') this.jump(this.maximum());
          else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
        }, {signal});
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.storyId === event.detail.blockId);
          if (card) this.jump(Math.min(this.maximum(), this.start(card)), true);
        }, {signal});
        this.resize = new ResizeObserver(() => this.schedule());
        this.resize.observe(this.track);
        this.cards.forEach(card => this.resize.observe(card));
        this.classList.add('is-ready');
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
      position() { return Math.max(0, Math.min(this.maximum(), (this.rtl ? -1 : 1) * this.track.scrollLeft)); }
      start(card) { return (this.rtl ? -1 : 1) * (card.offsetLeft - this.cards[0].offsetLeft); }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }
      update() {
        this.cards.forEach(card => {
          const text = card.querySelector('[data-story-text]');
          const button = card.querySelector('[data-story-expand]');
          if (!text || !button) return;
          button.hidden = button.getAttribute('aria-expanded') !== 'true' && text.scrollHeight <= text.clientHeight + 2;
        });
        const position = this.position(), maximum = this.maximum();
        this.previous.disabled = position <= 2;
        this.next.disabled = maximum - position <= 2;
        const columns = Math.max(1, Number(getComputedStyle(this).getPropertyValue('--ps-columns').trim()));
        let first = 0;
        this.cards.forEach((card,index) => { if (this.start(card) <= position + 5) first = index; });
        const last = Math.min(this.cards.length, first + columns);
        const key = first + ':' + last;
        if (this.range !== key) {
          this.querySelector('[data-stories-start]').textContent = String(first + 1).padStart(2,'0');
          this.querySelector('[data-stories-end]').textContent = String(last).padStart(2,'0');
          this.range = key;
        }
        this.querySelector('[data-stories-controls]').hidden = maximum <= 2;
        const trackBox = this.track.getBoundingClientRect();
        const trackStyle = getComputedStyle(this.track);
        const startPadding = parseFloat(trackStyle.paddingLeft), endPadding = parseFloat(trackStyle.paddingRight);
        const visible = this.cards.filter(card => {
          const box = card.getBoundingClientRect();
          return box.right > trackBox.left + startPadding + 2 && box.left < trackBox.right - endPadding - 2;
        });
        if (visible.length) {
          const contentHeight = Math.max(...visible.map(card => {
            const inner = card.querySelector('.ps__card');
            const shift = parseFloat(getComputedStyle(card).getPropertyValue('--ps-shift')) || 0;
            return Math.max(card.offsetHeight, inner.getBoundingClientRect().height + shift);
          }));
          const height = Math.ceil(contentHeight + parseFloat(trackStyle.paddingTop) + parseFloat(trackStyle.paddingBottom) + 4);
          if (this.track.style.height !== height + 'px') this.track.style.height = height + 'px';
        }
      }
      jump(position, immediate = false) {
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({left: (this.rtl ? -1 : 1) * position, behavior: immediate || reduce ? 'instant' : 'smooth'});
      }
      move(direction) {
        const position = this.position(), starts = this.cards.map(card => this.start(card));
        let target;
        if (direction > 0) target = starts.find(start => start > position + 5) ?? this.maximum();
        else target = starts.filter(start => start < position - 5).at(-1) ?? 0;
        this.jump(Math.min(this.maximum(), Math.max(0,target)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-social-posts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadTikTok = async (media) => {
      if (media.dataset.palmLoaded) return;
      media.dataset.palmLoaded = 'true';
      let postUrl;
      try { postUrl = new URL(media.dataset.palmTiktokUrl); } catch { return; }
      if (!['www.tiktok.com', 'tiktok.com', 'vm.tiktok.com', 'vt.tiktok.com'].includes(postUrl.hostname)) return;
      let id = postUrl.pathname.match(/\/(?:video|photo)\/(\d{10,25})(?:\/|$)/)?.[1];
      if (!id) {
        try {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 8000);
          const response = await fetch(`https://www.tiktok.com/oembed?url=${encodeURIComponent(postUrl.href)}`, { signal: controller.signal });
          clearTimeout(timeout);
          if (response.ok) {
            const result = await response.json();
            const doc = new DOMParser().parseFromString(result.html || '', 'text/html');
            id = doc.querySelector('[data-video-id]')?.getAttribute('data-video-id') || result.html?.match(/\/(?:video|photo)\/(\d{10,25})/)?.[1];
          }
        } catch {}
      }
      if (!id || !/^\d{10,25}$/.test(id)) {
        const loadingText = media.querySelector('.palm-social-posts__placeholder span:last-child');
        if (loadingText) loadingText.textContent = media.closest('.palm-social-posts__card')?.querySelector('.palm-social-posts__card-bottom a')?.textContent?.trim() || 'View original post';
        return;
      }
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.tiktok.com/player/v1/${id}?controls=1&description=0&music_info=0`;
      iframe.title = 'TikTok post';
      iframe.loading = 'lazy';
      iframe.allow = 'fullscreen; autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      media.replaceChildren(iframe);
    };
    const init = (root = document) => {
      const media = root.querySelectorAll('[data-palm-tiktok-url]');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) { observer.unobserve(entry.target); loadTikTok(entry.target); }
          });
        }, { rootMargin: '350px' });
        media.forEach((item) => observer.observe(item));
      } else media.forEach(loadTikTok);
      if (window.PinUtils?.build) window.PinUtils.build();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-product-complex"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-po-complex]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const tabs=[...section.querySelectorAll('[data-po-complex-tab]')];const panels=[...section.querySelectorAll('[data-po-complex-panel]')];const sticky=section.querySelector('.po-complex__sticky');const desktop=window.matchMedia('(min-width: 900px)');let index=0;let wheelLocked=false;const activate=next=>{index=Math.max(0,Math.min(next,tabs.length-1));tabs.forEach((tab,itemIndex)=>{const active=itemIndex===index;tab.classList.toggle('is-active',active);tab.setAttribute('aria-selected',active)});panels.forEach((panel,itemIndex)=>{const active=itemIndex===index;panel.classList.toggle('is-active',active);panel.setAttribute('aria-hidden',!active)})};const canLock=()=>{if(!desktop.matches)return false;const rect=sticky.getBoundingClientRect();const trigger=Math.min(100,window.innerHeight*.14);const lower=Math.min(window.innerHeight*.45,rect.height*.5);return rect.top<=trigger&&rect.bottom>=lower};const releaseWheel=()=>{window.setTimeout(()=>{wheelLocked=false},650)};tabs.forEach((tab,itemIndex)=>tab.addEventListener('click',()=>{activate(itemIndex);wheelLocked=true;releaseWheel()}));window.addEventListener('wheel',event=>{if(!canLock()||Math.abs(event.deltaY)<4)return;const forward=event.deltaY>0;if((forward&&index===tabs.length-1)||(!forward&&index===0))return;event.preventDefault();if(wheelLocked)return;wheelLocked=true;activate(index+(forward?1:-1));releaseWheel()},{passive:false})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["po-product-targets"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-po-targets]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const activate=id=>{section.querySelectorAll('[data-po-target]').forEach(button=>{const active=button.dataset.poTarget===id;button.classList.toggle('is-active',active);if(button.classList.contains('po-targets__hotspot'))button.setAttribute('aria-pressed',active)});section.querySelectorAll('[data-po-panel]').forEach(panel=>{const active=panel.dataset.poPanel===id;panel.classList.toggle('is-active',active);panel.hidden=!active})};section.addEventListener('click',event=>{const button=event.target.closest('[data-po-target]');if(button&&section.contains(button))activate(button.dataset.poTarget)})})})();

  } catch(e) { console.error(e); }
})();
})();
